<script>

import { useToast } from "vue-toastification";

import LoadingScreen from '@/components/General/LoadingScreen'
import Alert from '@/components/General/Alert'

import MyPagination from '@/components/SystemElements/PaginationV2.vue'
import MyCountRecords from '@/components/SystemElements/CountRecordsOptionsV2.vue'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

import UserCircle from '@/ui/UserCircle'

//data
import { getUserSysLogs, getUser, unlockUser } from '@/services/serviceUser';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'UserSysLogs',
	mixins: [ MixinGeneralFunct ],
	components: {
		LoadingScreen
		,MyPagination
		,MyCountRecords
		,Alert
		,UserCircle
	},
	props: {'userId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["userId","changeRecord"],
	data() {
		return {
			prefix:'',
		
			metaData: [],
			
			menuItems: [],
			isLoading:false,
			
			selectedPage:1,
			selectedRecords:10,
			selectedCol:'a.id',
			selectedSort:'desc',
											
			filterExtended:false,
			showFilter:false,
			
			totalCount:0,
			dataList:[],
			
			user:[],
			selectedFilterText:''
		}
	},
	
	mounted:function(){
	
	},
	
	methods: {
		// load data form
		onLoadPage:function(){
			
			this.isLoading=true

			getUserSysLogs({filterText: this.selectedFilterText, orderCol: this.selectedCol, orderSort: this.selectedSort, page: this.selectedPage, records: this.selectedRecords, userId:this.userId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					this.dataList = response.results;
					this.metaData = response.metaData;
					this.totalCount = response.totalCount;

				}else{
					this.isLoading=false
					this.errorStatus=`${response.statusText} ${response.status}`
				}
			});


			getUser({userId:this.userId}).then(response => {
				if(!response.statusText){
					this.user = response.data;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
			
		},
		
		
		onClose:function(){
			if(this.userId!='null'){
				unlockUser({userId:this.userId}).then(response => {
					if(!response.statusText){
						this.isLoading=false
						if(response.resCode==1){
							this.$emit('changeRecord', '')
							this.modalObject.hide();
						}
					}else{
						this.isLoading=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
			}else{
				this.$emit('changeRecord', '')
				this.modalObject.hide();
			}
		},
		
		//radenie zoznamu - orders by
		orderByCol:function(col){
			
			if(col === this.selectedCol) {
				this.selectedSort = this.selectedSort==='asc'?'desc':'asc';
			}
			this.selectedCol = col;
			
			this.onLoadPage();
		},
		
		//vyber stranky v strankovaci
		onChangePage(selectedPage) {
			this.selectedPage=selectedPage
			this.onLoadPage();
		},

		//vyber poctu zaznamov
		onChangeRecords(selectedCount) {
			this.selectedPage=1;
			this.selectedRecords=selectedCount
			this.onLoadPage();
		},

		//active menu
		isActive: function (col) {
			return this.selectedCol === col;
		},
		isAsc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'asc'){
				return true;
			}
		},
		isDesc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'desc'){
				return true;
			}
		},
		
		//vycisti text filter
		resetTextFilter: function(){
			this.selectedFilterText = '';
			this.onLoadPage();
		},
		
	},
	
	watch: {
		userId() {
			this.onLoadPage();
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-dialog-scrollable modal-fullscreen">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
			<div class="modal-content">
				<div class="modal-header">
					<h6 class="modal-title">{{ $t('msgCore.User') }} - {{ $t('msgCore.sysLogData') }} <b><span>{{ user.name }} {{ user.surname }}</span></b></h6>
				</div>
		
				<div v-if="metaData.modulAccess && auth.usersShowSysLogData" class="modal-body">
					
					<div class="row">
						<div class="col-12">
								
							<!-- filters basic -->
							<div class="row">
								<div class="input-group col-md-4 col-12">
									<button type="button" :title="$t('msgCore.btnFilter')" class="btn btn-info btn-sm my-btn" v-on:click="showFilters()">
										<span v-if="filterExtended">
											<i v-if="!showFilter" class="smire-icon fas fa-search-plus"></i> 
											<i v-else class="smire-icon fas fa-search-minus"></i>
										</span>
										<span v-else>
											<i class="smire-icon fas fa-search"></i> 
										</span>
										{{ $t('msgCore.btnFilter') }}
									</button>
									<input type="text" class="form-control form-control-sm" v-model='selectedFilterText' :placeholder="$t('msgCore.searchTitle')" v-on:change="onLoadPage()">
									<button type="button" :title="$t('msgCore.btnStorno')" class="btn btn-outline-info btn-sm my-btn" v-on:click="resetTextFilter()">
										<i class="smire-icon fas fa-times"></i>
									</button>
								</div>
							</div>
							
							<!-- filters extended -->
							<div v-show="showFilter && filterExtended" class="row">
								<div class="col-12">
									<div class="row">
										
									</div>
								</div>
							</div>
								
						</div>
					</div>
					
					<!-- zakladny zoznam -->
					<div v-if="totalCount>0">
					
						<div class="row">
							<div class="col-12">
			
								<div class="table-responsive">
									<table class="table table-hover table-sm">
									
										<thead>
											<tr>
												
												<th>{{$t('msgCore.Type')}}</th>
											
												<th>{{$t('msgCore.Text')}}</th>
												
												<th>{{$t('msgCore.Table')}}</th>
												
												<th>{{$t('msgCore.Created')}}</th>
												
												<th>{{$t('msgCore.CreatedBy')}}</th>
												
												<th  width="20" class="orderBy" v-on:click="sort('id')" :class="{ active: isActive('id'), asc: isAsc('id'), desc: isDesc('id')}">{{$t('msgCore.id')}}</th>
												
											</tr>
										</thead>
										
										
										<tr v-for="(basicObj) in dataList" :key="basicObj" >
																					
											<td>{{ basicObj.type }}</td>
											
											<td>{{ basicObj.string }}</td>
											
											<td>{{ basicObj.in_table }}</td>
											
											<td>{{ basicObj.createdView }}</td>
											
											<td>
												<UserCircle :firstName="basicObj.creatorFirstName" :surName="basicObj.creatorSurName" :color="basicObj.creatorColor" :date="basicObj.created"/>
											</td>
																							
											<td>{{ basicObj.id }}</td>
											
										</tr>
										
									</table>	
								</div>		
							
							</div>
						</div>
							
						<div class="row row-pagination">
							<div class="col-6 col-md-3 col-lg-2">
								<MyCountRecords :selectedRecords="selectedRecords" @onSelectRecords="onChangeRecords"></MyCountRecords>
							</div>
							
							<div class="col-6 col-md-3 col-lg-2 box-flex">
								<span>Počet: {{totalCount}} </span>
							</div>
							
							<div class="col-12 col-md-6 col-lg-8">	
								<MyPagination :selectedRecords="selectedRecords" :totalCount="totalCount" :selectedPage="selectedPage" @onSelectPage="onChangePage"></MyPagination>
							</div>
						</div>
						
						
						
					</div>	
					
					<div v-else class="row">
						<div class="col-12 mt-3">
							<Alert type="warning" :label="$t('msgCore.forThisSelectExistAnyData')" />
						</div>							
					</div>

				</div>
				
				<div v-else class="modal-body">
					<div class="row">
						<div class="col-12 mt-3">
							<Alert type="warning" :label="$t('msgCore.accessDenied')" />
						</div>
					</div>
				</div>
				
				<div class="modal-footer">
					<div class="btn-group">
						<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
					</div>	
				</div>
					
			</div>

		</div>
		
	</div>
	</div>
		
</template>


